import { render } from "./FaqEditItemInstructions.vue?vue&type=template&id=68be0288"
import script from "./FaqEditItemInstructions.vue?vue&type=script&lang=js"
export * from "./FaqEditItemInstructions.vue?vue&type=script&lang=js"
script.render = render

export default script